webpackJsonp([17],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "5inX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"breakpoint-not-small":"screen and (min-width: 30em)","breakpoint-small-medium":"screen and (max-width: 45em)","breakpoint-medium":"screen and (min-width: 30em) and (max-width: 60em)","breakpoint-large":"screen and (min-width: 60em)","breakpoint-small":"screen and (max-width: 30em)"};

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var getters_namespaceObject = {};
__webpack_require__.d(getters_namespaceObject, "user", function() { return getters_user; });
__webpack_require__.d(getters_namespaceObject, "dms", function() { return dms; });
var mutations_namespaceObject = {};
__webpack_require__.d(mutations_namespaceObject, "UPDATE_AUTH", function() { return UPDATE_AUTH; });
__webpack_require__.d(mutations_namespaceObject, "UPDATE_USER", function() { return UPDATE_USER; });
__webpack_require__.d(mutations_namespaceObject, "APPNAV_SEARCH", function() { return APPNAV_SEARCH; });
__webpack_require__.d(mutations_namespaceObject, "SEND_DM", function() { return SEND_DM; });
__webpack_require__.d(mutations_namespaceObject, "CLEAR_ALL_DATA", function() { return CLEAR_ALL_DATA; });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/index.js



vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  routes: [
  // Each of these routes are loaded asynchronously, when a user first navigates to each corresponding endpoint.
  // The route will load once into memory, the first time it's called, and no more on future calls.
  // This behavior can be observed on the network tab of your browser dev tools.
  {
    path: '/',
    name: 'home',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("h6qm")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/privacy',
    name: 'privacy',
    component: function component(resolve) {
      __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xTHq")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/terms',
    name: 'terms',
    component: function component(resolve) {
      __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lAtr")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/login',
    name: 'login',
    component: function component(resolve) {
      __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NaOX")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/signup',
    name: 'signup',
    component: function component(resolve) {
      __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("7cLI")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    props: function props(route) {
      return {
        query: route.query.email
      };
    }
  }, {
    path: '/about',
    name: 'about',
    component: function component(resolve) {
      __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ezOL")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/create',
    name: 'create',
    component: function component(resolve) {
      __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("yJbL")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    beforeEnter: guardRoute
  }, {
    path: '/profile/:username',
    name: 'profile',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("LZXq")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    props: true
  }, {
    path: '/edit/profile',
    name: 'edit profile',
    component: function component(resolve) {
      __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/a1K")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    beforeEnter: guardRoute
  }, {
    path: '/addresses',
    name: 'addresses',
    component: function component(resolve) {
      __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MyAy")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    beforeEnter: guardRoute
  }, {
    path: '/setup',
    name: 'setup',
    component: function component(resolve) {
      __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lI3F")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/how',
    name: 'how',
    component: function component(resolve) {
      __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("E7G6")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/chats',
    name: 'chats',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("o5Hg")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    beforeEnter: guardRoute
  }, {
    path: '/chats/:username',
    name: 'user chat',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Dhqr")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    beforeEnter: guardRoute,
    props: true
  }, {
    path: '/view/:id',
    name: 'view',
    component: function component(resolve) {
      Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/8xE")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    props: true
  }]
});

function guardRoute(to, from, next) {
  var auth = router.app.$options.store.state.auth;
  if (!auth.isLoggedIn) {
    next({
      path: '/login',
      query: {
        redirect: to.name
      }
    });
  } else {
    next();
  }
}

/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/store/state.js
// Set the key we'll use in local storage.
// Go to Chrome dev tools, application tab, click "Local Storage" and "http://localhost:8080"
// and you'll see this key set below (if logged in):
var STORAGE_KEY = 'cryptogigs.co';

var initialState = {};

// Local storage sync state
if (localStorage.getItem(STORAGE_KEY)) {
  initialState = JSON.parse(localStorage.getItem(STORAGE_KEY));
} else {
  initialState = {
    auth: {
      isLoggedIn: false
    },
    user: {
      username: '',
      photoURL: '',
      email: '',
      uid: ''
    }
  };
}

// Other state (not synced in local storage)
initialState.appnav = {
  searchText: '',
  searchTimestamp: null

  // Chats
};initialState.chats = [];

// DMs
initialState.dms = [];

var state_state = initialState;
// CONCATENATED MODULE: ./src/store/getters.js
var getters_user = function user(state) {
  return state.user;
};
var dms = function dms(state) {
  return state.dms;
};
// EXTERNAL MODULE: ./src/store/actions.js
var actions = __webpack_require__("mUbh");
var actions_default = /*#__PURE__*/__webpack_require__.n(actions);

// CONCATENATED MODULE: ./src/store/mutations.js
var UPDATE_AUTH = function UPDATE_AUTH(state, auth) {
  state.auth = auth;
};

var UPDATE_USER = function UPDATE_USER(state, user) {
  state.user = user;
};

var APPNAV_SEARCH = function APPNAV_SEARCH(state, searchData) {
  state.appnav = searchData;
};

var SEND_DM = function SEND_DM(state, message) {
  state.dms.push(message);
};

/**
 * Clear each property, one by one, so reactivity still works.
 *
 * (ie. clear out state.auth.isLoggedIn so Navbar component automatically reacts to logged out state,
 * and the Navbar menu adjusts accordingly)
 *
 * TODO: use a common import of default state to reset these values with.
 */
var CLEAR_ALL_DATA = function CLEAR_ALL_DATA(state) {
  // Auth
  state.auth.isLoggedIn = false;
  state.auth.accessToken = null;
  state.auth.refreshToken = null;

  // User
  state.user.username = '';
  state.user.photoURL = '';
  state.user.email = '';
  state.user.uid = '';
};
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./src/store/plugins.js



var plugins_localStoragePlugin = function localStoragePlugin(store) {
  store.subscribe(function (mutation, state) {
    var syncedData = { auth: state.auth, user: state.user };

    localStorage.setItem(STORAGE_KEY, stringify_default()(syncedData));

    if (mutation.type === 'CLEAR_ALL_DATA') {
      localStorage.removeItem(STORAGE_KEY);
    }
  });
};

// TODO: setup env
// export default process.env.NODE_ENV !== 'production' ? [localStoragePlugin] : [localStoragePlugin]
/* harmony default export */ var plugins = ([plugins_localStoragePlugin]);
// CONCATENATED MODULE: ./src/store/index.js








vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var store_store = new vuex_esm["a" /* default */].Store({
  state: state_state,
  getters: getters_namespaceObject,
  actions: actions,
  mutations: mutations_namespaceObject,
  plugins: plugins
});

/* harmony default export */ var src_store = (store_store);
// EXTERNAL MODULE: ./node_modules/vue-resource/dist/vue-resource.es2015.js
var vue_resource_es2015 = __webpack_require__("ORbq");

// EXTERNAL MODULE: ./src/assets/style/app.scss
var app = __webpack_require__("5inX");
var app_default = /*#__PURE__*/__webpack_require__.n(app);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppNav.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Auth from '@/auth'
/* harmony default export */ var AppNav = ({
  data: function data() {
    return {
      auth: this.$store.state.auth,
      currentUser: this.$store.state.user
    };
  },

  // created () {
  //   // console.log(this.currentUser)
  //   // this.logout()
  // },
  watch: {
    '$route': 'checkAuth',
    'currentUser': 'checkAuth'
  },
  methods: {
    checkAuth: function checkAuth() {
      // console.log(this.$store.state.user)
      this.currentUser = this.$store.state.user;
    }
    // logout () {
    //   Auth.logout()
    // }
    // submitSearch () {
    //   this.$store.commit(
    //     'APPNAV_SEARCH',
    //     {
    //       searchText: this.searchText,
    //       searchTimestamp: Date.now()
    //     }
    //   )
    // }

  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f21aabc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppNav.vue
var AppNav_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"dib fixed-ns relative w-100 bg-white z-1"},[_c('div',{staticClass:"db center w-100 mw8-ns flex justify-between"},[_c('router-link',{staticClass:"dib link navy hover-blue b no-underline flex items-center pa3 brand",attrs:{"to":{ name: 'home' },"href":"/"}},[_c('svg',{staticClass:"dib relative v-mid mr2 logo",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1024 1024"}},[_c('title',[_vm._v("cryptogigs.co")]),_c('path',{attrs:{"d":"M767,604a157.7,157.7,0,0,1,22,80c0,87-71,158-158,158a158.9,158.9,0,0,1-119-54,157.2,157.2,0,0,1-119,54c-87,0-158-71-158-158a155.1,155.1,0,0,1,22-80,157.4,157.4,0,0,1-95-145c0-87,71-158,158-158a140.8,140.8,0,0,1,35,4c7-80,75-143,157-143s150,63,157,143c11-2,23-4,35-4,87,0,158,71,158,158a157.4,157.4,0,0,1-95,145ZM512,12C236,12,12,236,12,512s224,500,500,500,500-224,500-500S788,12,512,12Z"}})]),_vm._v(" "),_c('span',{staticClass:"dn dib-ns v-mid relative"},[_vm._v("cryptogigs.co")])]),_vm._v(" "),_c('div',{staticClass:"flex-grow pa3 flex items-center"},[_c('router-link',{staticClass:"dn dib-ns f6 link hover-blue pv1 ph2 navy relative mr2",attrs:{"to":{ name: 'about' }}},[_vm._v("\n        About\n      ")]),_vm._v(" "),(_vm.auth.isLoggedIn)?[_c('router-link',{staticClass:"f6 link hover-blue pv1 ph2 navy relative mr2",attrs:{"to":{ name: 'chats' }}},[_vm._v("\n          Chats\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"f6 link hover-blue pv1 ph2 navy relative mr2",attrs:{"to":{ name: 'profile', params: { username: _vm.currentUser.username } }}},[_vm._v("\n          My Profile\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"dib f6 b link hover-blue pv2 ph3 bg-light-green br3 navy relative",attrs:{"to":{ name: 'create' }}},[_vm._v("\n          + New Post\n        ")])]:[_c('router-link',{staticClass:"dib f6 link hover-blue pv1 ph2 navy relative mr2",attrs:{"to":{ name: 'login' }}},[_vm._v("\n          Login\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"dib f6 b link hover-blue pv2 ph3 bg-light-green br3 navy relative",attrs:{"to":{ name: 'signup' }}},[_vm._v("\n          Start Earning\n        ")])]],2)],1)])}
var staticRenderFns = []
var esExports = { render: AppNav_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_AppNav = (esExports);
// CONCATENATED MODULE: ./src/components/AppNav.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  AppNav,
  components_AppNav,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_AppNav = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/firebase/index.js
var firebase = __webpack_require__("Sazm");
var firebase_default = /*#__PURE__*/__webpack_require__.n(firebase);

// CONCATENATED MODULE: ./src/auth.js

// Vue






/* harmony default export */ var src_auth = ({
  /**
   * Install the Auth class.
   *
   * Creates a Vue-resource http interceptor to handle automatically adding auth headers
   * and refreshing tokens. Then attaches this object to the global Vue (as Vue.auth).
   *
   * @param {Object} Vue The global Vue.
   * @param {Object} options Any options we want to have in our plugin.
   * @return {void}
   */
  install: function install(Vue, options) {
    // Vue.http.interceptors.push((request, next) => {
    //   const token = store.state.auth.accessToken
    //   const hasAuthHeader = request.headers.has('Authorization')

    //   if (token && !hasAuthHeader) {
    //     this.setAuthHeader(request)
    //   }

    //   next((response) => {
    //     if (this._isInvalidToken(response)) {
    //       return this._refreshToken(request)
    //     }
    //   })
    // })

    Vue.prototype.$auth = Vue.auth = this;
  },


  /**
   * Check current user
   *
   */
  checkCurrentUser: function checkCurrentUser() {
    return new promise_default.a(function (resolve, reject) {
      firebase_default.a.auth().onAuthStateChanged(function (user) {
        if (user) {
          var data = {
            emailVerified: user.emailVerified,
            username: user.displayName,
            photoURL: user.photoURL,
            uid: user.uid
            // console.log(data)
          };resolve(data);
        } else {
          reject();
        }
      });
    });
  },


  /**
   * Signup
   *
   * @param {Object.<string>} creds The username and password for logging in.
   * @param {string|null} redirect The name of the Route to redirect to.
   * @return {Promise}
   */
  signup: function signup(creds, file, redirect) {
    var _this = this;

    return new promise_default.a(function (resolve, reject) {
      firebase_default.a.auth().createUserWithEmailAndPassword(creds.email, creds.password).then(function (user) {
        // Get current user
        var currentUser = firebase_default.a.auth().currentUser;

        if (file) {
          // Todo: NOT HACK THIS
          var progress = 0;
          vue_esm["a" /* default */].prototype.$Progress.start();

          var storageRef = firebase_default.a.storage().ref('avatars/' + currentUser.uid + '/' + file.name);
          var task = storageRef.put(file);

          task.on('state_changed',
          // progress
          function (snapshot) {
            // console.log('progress', snapshot)
            progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
            vue_esm["a" /* default */].prototype.$Progress.set(progress);
          },
          // error
          function (snapshot) {
            console.error('error', snapshot);
          },
          // complete
          function (snapshot) {
            // console.log('complete')
            var updateData = {
              displayName: creds.username,
              photoURL: task.snapshot.downloadURL
            };
            currentUser.updateProfile(updateData).then(function () {
              // console.log('Added username and photo')

              var userData = {
                created: Date.now(),
                emailVerified: currentUser.emailVerified,
                username: currentUser.displayName,
                photoURL: task.snapshot.downloadURL,
                email: currentUser.email,
                uid: currentUser.uid
              };

              _this._storeUser(userData);

              vue_esm["a" /* default */].prototype.$ga.event({
                eventCategory: 'auth',
                eventAction: 'completed_signup',
                eventLabel: 'username',
                eventValue: userData.username
              });

              firebase_default.a.firestore().collection('users').doc(userData.username).set(userData).then(function (docRef) {
                if (redirect) {
                  src_router.push({ name: redirect });
                }
                resolve(currentUser);
              }).catch(function (error) {
                reject(error);
              });
            }).catch(function (error) {
              // todo: if error then update the username later or re-try
              console.log(error);
              reject(error);
            });
          });
        } else if (!file) {
          var updateData = {
            displayName: creds.username
          };
          currentUser.updateProfile(updateData).then(function () {
            // console.log('Added username')

            var userData = {
              created: Date.now(),
              emailVerified: currentUser.emailVerified,
              username: currentUser.displayName,
              photoURL: currentUser.photoURL,
              email: currentUser.email,
              uid: currentUser.uid
            };

            _this._storeUser(userData);

            vue_esm["a" /* default */].prototype.$ga.event({
              eventCategory: 'auth',
              eventAction: 'completed_signup',
              eventLabel: 'username',
              eventValue: userData.username
            });

            firebase_default.a.firestore().collection('users').doc(userData.username).set(userData).then(function (docRef) {
              if (redirect) {
                src_router.push({ name: redirect });
              }
              resolve(currentUser);
            }).catch(function (error) {
              reject(error);
            });
          }).catch(function (error) {
            // todo: if error then update the username later or re-try
            console.log(error);
            reject(error);
          });
        }
      }).catch(function (error) {
        console.log('register error', error);
        reject(error);
      });
    });
  },


  /**
   * Login
   *
   * @param {Object.<string>} creds The username and password for logging in.
   * @param {string|null} redirect The name of the Route to redirect to.
   * @return {Promise}
   */
  login: function login(creds, redirect) {
    var _this2 = this;

    return new promise_default.a(function (resolve, reject) {
      firebase_default.a.auth().signInWithEmailAndPassword(creds.email, creds.password).then(function (user) {
        // console.log(user)

        var userData = {
          emailVerified: user.emailVerified,
          username: user.displayName,
          photoURL: user.photoURL,
          email: user.email,
          uid: user.uid
        };

        _this2._storeUser(userData);

        if (redirect) {
          src_router.push({ name: redirect });
        }

        vue_esm["a" /* default */].prototype.$ga.event({
          eventCategory: 'auth',
          eventAction: 'completed_login',
          eventLabel: 'username',
          eventValue: user.displayName
        });

        resolve(user);
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },


  /**
   * Logout
   *
   * Clear all data in our Vuex store (which resets logged-in status) and redirect back
   * to login form.
   *
   * @return {void}
   */
  logout: function logout() {
    var user = src_store.state.user;
    vue_esm["a" /* default */].prototype.$ga.event({
      eventCategory: 'logout',
      eventAction: 'completed_logout',
      eventLabel: 'username',
      eventValue: user.username
    });
    setTimeout(function () {
      src_store.commit('CLEAR_ALL_DATA');
    }, 500);
    return firebase_default.a.auth().signOut().then(function (loggedOut) {
      src_router.push({ name: 'home' });
    }).catch(function (error) {
      console.log(error);
      src_router.push({ name: 'home' });
    });
  },


  /**
   * Store tokens
   *
   * Update the Vuex store with the access/refresh tokens received from the response from
   * the Oauth2 server.
   *
   * @private
   * @param {Response} response Vue-resource Response instance from an OAuth2 server.
   *      that contains our tokens.
   * @return {void}
   */
  _storeUser: function _storeUser(data) {
    // console.log(data)
    var auth = src_store.state.auth;
    var user = data;

    // console.log(auth, user)

    auth.isLoggedIn = true;
    // auth.accessToken = response.body.access_token
    // auth.refreshToken = response.body.refresh_token
    // TODO: get user's name from response from Oauth server.
    // user.name = 'John Smith'

    src_store.commit('UPDATE_AUTH', auth);
    src_store.commit('UPDATE_USER', user);
  },


  // Todo: upload file helper
  _uploadFile: function _uploadFile(route, file) {
    var storageRef = firebase_default.a.storage().ref(route.toString() + file.name);
    var task = storageRef.put(file);
    var downloadURL = task.snapshot.downloadURL;

    var response = void 0;
    task.on('state_changed',
    // progress
    function (snapshot) {
      console.log('progress', snapshot);
      response = downloadURL;
    },
    // error
    function (snapshot) {
      console.error('error', snapshot);
      response = false;
    },
    // complete
    function (snapshot) {
      console.log('complete');
      response = true;
    });
    return response;
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AppFooter.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var AppFooter = ({
  name: 'Footer',
  data: function data() {
    return {
      auth: this.$store.state.auth,
      currentYear: new Date().getFullYear()
    };
  },

  methods: {
    logout: function logout() {
      src_auth.logout();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37cae40c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFooter.vue
var AppFooter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"db center w-100 mw8-ns ph3 pv5 bn navy"},[_c('a',{staticClass:"link b f3 f2-ns dim lh-solid navy",attrs:{"href":"mailto:hello@cryptogigs.co"}},[_vm._v("hello@cryptogigs.co")]),_vm._v(" "),_c('p',{staticClass:"f6 db b ttu lh-solid o-80"},[_vm._v("© "+_vm._s(_vm.currentYear)+" cryptogigs.co inc")]),_vm._v(" "),_c('div',{staticClass:"mt5"},[_c('router-link',{staticClass:"f6 dib pr2 mid-gray dim",attrs:{"to":{ name: 'about' },"title":"About"}},[_vm._v("\n      About\n    ")]),_vm._v(" "),_c('router-link',{staticClass:"f6 dib ph2 mid-gray dim",attrs:{"to":{ name: 'terms' },"title":"Terms"}},[_vm._v("\n      Terms\n    ")]),_vm._v(" "),_c('router-link',{staticClass:"f6 dib pl2 mid-gray dim",attrs:{"to":{ name: 'privacy' },"title":"Privacy"}},[_vm._v("\n      Privacy\n    ")])],1)])}
var AppFooter_staticRenderFns = []
var AppFooter_esExports = { render: AppFooter_render, staticRenderFns: AppFooter_staticRenderFns }
/* harmony default export */ var components_AppFooter = (AppFooter_esExports);
// CONCATENATED MODULE: ./src/components/AppFooter.vue
var AppFooter_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AppFooter___vue_template_functional__ = false
/* styles */
var AppFooter___vue_styles__ = null
/* scopeId */
var AppFooter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AppFooter___vue_module_identifier__ = null
var AppFooter_Component = AppFooter_normalizeComponent(
  AppFooter,
  components_AppFooter,
  AppFooter___vue_template_functional__,
  AppFooter___vue_styles__,
  AppFooter___vue_scopeId__,
  AppFooter___vue_module_identifier__
)

/* harmony default export */ var src_components_AppFooter = (AppFooter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var App = ({
  name: 'app',
  components: { AppNav: src_components_AppNav, AppFooter: src_components_AppFooter },
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-816e69b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-nav'),_vm._v(" "),_c('div',{staticClass:"app-content"},[_c('vue-progress-bar'),_vm._v(" "),_c('v-dialog',{attrs:{"name":"signup-error"}},[_c('div',{staticClass:"dib pa4 w-100"},[_c('p',{staticClass:"f2 fw5"},[_vm._v("\n          Oh no... 😱\n        ")]),_vm._v(" "),_c('p')])]),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath})],1),_vm._v(" "),_c('app-footer')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var components_App = (App_esExports);
// CONCATENATED MODULE: ./src/components/App.vue
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = null
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  components_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_components_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/vue-lodash/dist/vue-lodash.min.js
var vue_lodash_min = __webpack_require__("NETs");
var vue_lodash_min_default = /*#__PURE__*/__webpack_require__.n(vue_lodash_min);

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// EXTERNAL MODULE: ./node_modules/vue-js-modal/dist/index.js
var dist = __webpack_require__("rifk");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/vue-progressbar/dist/vue-progressbar.js
var vue_progressbar = __webpack_require__("zYko");
var vue_progressbar_default = /*#__PURE__*/__webpack_require__.n(vue_progressbar);

// EXTERNAL MODULE: ./node_modules/vue-textarea-autosize/index.js
var vue_textarea_autosize = __webpack_require__("ptVh");

// EXTERNAL MODULE: ./node_modules/vue-social-sharing/dist/vue-social-sharing.common.js
var vue_social_sharing_common = __webpack_require__("VK1f");
var vue_social_sharing_common_default = /*#__PURE__*/__webpack_require__.n(vue_social_sharing_common);

// EXTERNAL MODULE: ./node_modules/vue-head/vue-head.js
var vue_head = __webpack_require__("RZCy");
var vue_head_default = /*#__PURE__*/__webpack_require__.n(vue_head);

// EXTERNAL MODULE: ./node_modules/firebase/firestore/index.js
var firestore = __webpack_require__("3VHS");
var firestore_default = /*#__PURE__*/__webpack_require__.n(firestore);

// CONCATENATED MODULE: ./src/main.js
var main__this = this;

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

/* Vue */





vue_esm["a" /* default */].use(vue_resource_es2015["a" /* default */]);
vue_esm["a" /* default */].config.productionTip = false;

/* App sass */


/* App component */


/* Auth plugin */

vue_esm["a" /* default */].use(src_auth);

/* Lodash */


vue_esm["a" /* default */].use(vue_lodash_min_default.a, lodash_default.a);

/* Google analytics */

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-109915355-1',
  checkDuplicatedScript: true,
  autoTracking: {
    exception: true
  },
  router: src_router
});

/* Validation */

vue_esm["a" /* default */].use(vee_validate_esm["a" /* default */]);

/* Modal */

vue_esm["a" /* default */].use(dist_default.a, {
  dialog: true,
  adaptive: true
});

/* Progress bar */

var progressBarOptions = {
  color: 'rgb(154, 102, 255)',
  failedColor: 'red',
  thickness: '3px'
};
vue_esm["a" /* default */].use(vue_progressbar_default.a, progressBarOptions);

/* Autosize textarea */

vue_esm["a" /* default */].use(vue_textarea_autosize["default"]);

/* Social share */

vue_esm["a" /* default */].use(vue_social_sharing_common_default.a);

/* Edit metatags */

vue_esm["a" /* default */].use(vue_head_default.a);

/* Firebase */


var firebaseConfig = {
  apiKey: 'AIzaSyDesDpigAYtKwDWyMHI9jfcTJ9-c23Gub8',
  authDomain: 'cryptogig-64be9.firebaseapp.com',
  databaseURL: 'https://cryptogig-64be9.firebaseio.com',
  projectId: 'cryptogig-64be9',
  storageBucket: 'cryptogig-64be9.appspot.com',
  messagingSenderId: '237985771420'

  /* eslint-disable no-new */
};new vue_esm["a" /* default */]({
  el: '#app',
  // Attach the Vue instance to the window,
  // so it's available globally.
  created: function created() {
    firebase_default.a.initializeApp(firebaseConfig);
    window.Vue = main__this;
  },
  router: src_router,
  store: src_store,
  render: function render(h) {
    return h(src_components_App);
  }
});

/***/ }),

/***/ "mUbh":
/***/ (function(module, exports) {

// Here is where you can put async operations.
// See the Vuex official docs for more information.

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.4e340126ef9e5378cd76.js